import axios from "axios";

import { basePath, createHeaders } from "./utils";

/**
 * GET
 * /api/maintenance/equipment/{equipmentId: string($uuid)}
 * 
 * Returns all maintenance records for a station
 */
export const getMaintenanceRecords = (equipmentId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/maintenance/equipment/${equipmentId}`, config)
      .then((resp) => {
        console.log("getMaintenanceRecords", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * POST
 * /api/maintenance/equipment/{equipmentId: string{$uuid}}
 * 
 * Create maintenance record and update index for equipmentId
 */
export const postMaintenanceRecord = (equipmentId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(`${basePath}/maintenance/equipment/${equipmentId}`, null, config)
      .then((resp) => {
        console.log("postMaintenanceRecord", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/maintenance/types
 * 
 * Returns all maintenance types
 */
export const getMaintenanceTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/maintenance/types`, config)
      .then((resp) => {
        console.log("getMaintenanceTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/maintenance/status/types
 * 
 * Returns all maintenance status types
 */
export const getMaintenanceStatusTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/maintenance/status/types`, config)
      .then((resp) => {
        console.log("getMaintenanceStatusTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
